"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _static = require("../static");
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var _transformState = _interopRequireDefault(require("@/utils/transformState.js"));
var dangaoActApi = _interopRequireWildcard(require("@/api/dangaoActApi"));
var orderListApi = _interopRequireWildcard(require("@/api/orderListApi.js"));
var customerOrderApi = _interopRequireWildcard(require("@/api/customerOrderApi.js"));
var _constants = require("@/utils/constants");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      orderStateOption: _static.orderStateOption,
      offsetStateOption: _static.offsetStateOption,
      constants: this.$constants,
      companyappAutoList: [],
      companyappAutoListA: [],
      companyappAutoListB: [],
      dataRenage: [],
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0],
        type: 2
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      storeType: false,
      formStoreSelect: [],
      formStoreSelectedOne: [],
      orderListWx: [],
      dialogVisibleDetals: false,
      popupDetales: {},
      serviceList: [{
        name: '报告解读',
        used: '',
        remain: ''
      }, {
        name: '门诊预约',
        used: '',
        remain: ''
      }, {
        name: '陪诊服务',
        used: '',
        remain: ''
      }]
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.handleApiOffsetList(this.listPram);
  },
  methods: {
    throttle: _throttle.default,
    transformState: _transformState.default,
    // 核销订单列表
    handleApiOffsetList: function () {
      var _handleApiOffsetList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(listPram) {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return orderListApi.orderSjtList(listPram);
            case 1:
              res = _context.v;
              this.listData.list = res.list;
              this.listData.total = res.total;
              this.listLoading = false;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function handleApiOffsetList(_x) {
        return _handleApiOffsetList.apply(this, arguments);
      }
      return handleApiOffsetList;
    }(),
    // 获取到商家列表 当缓存里没有时调
    handleStoreListSelect: function () {
      var _handleStoreListSelect = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return customerOrderApi.companyAutoListByTypetApi({
                type: 4
              });
            case 1:
              res = _context2.v;
              this.storeType = true;
              this.formStoreSelect = res;
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function handleStoreListSelect() {
        return _handleStoreListSelect.apply(this, arguments);
      }
      return handleStoreListSelect;
    }(),
    //获取到店铺列表
    handleSelectedList: function () {
      var _handleSelectedList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return customerOrderApi.companyAutoListByTypestApi({
                offlineSupplierId: this.listPram.offlineSupplierId
              });
            case 1:
              res = _context3.v;
              this.formStoreSelectedOne = res;
              this.handerSearch();
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function handleSelectedList() {
        return _handleSelectedList.apply(this, arguments);
      }
      return handleSelectedList;
    }(),
    // 获取小程序的列表
    handleAppWxOrderList: function () {
      var _handleAppWxOrderList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return customerOrderApi.companyappAutoListApi();
            case 1:
              res = _context4.v;
              this.orderListWx = res;
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function handleAppWxOrderList() {
        return _handleAppWxOrderList.apply(this, arguments);
      }
      return handleAppWxOrderList;
    }(),
    // 搜索
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handleApiOffsetList(this.listPram);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handleApiOffsetList(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handleApiOffsetList(this.listPram);
    },
    // 查看订单详情
    openOrderDetail: function () {
      var _openOrderDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(row) {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              console.log(row);
              this.dialogVisibleDetals = true;
              _context5.n = 1;
              return orderListApi.orderSjtGetDetail({
                orderNo: row.orderNo
              });
            case 1:
              res = _context5.v;
              console.log(res, 'RES');
              this.popupDetales = res;
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function openOrderDetail(_x2) {
        return _openOrderDetail.apply(this, arguments);
      }
      return openOrderDetail;
    }(),
    // 导出
    claerPamrs: function claerPamrs() {
      this.listPram.keyword = '';
      this.listPram.orderStatus = '';
      this.listPram.validityStatus = '';
    }
  }
};